import { Injectable } from '@angular/core';
import { AbstractDataServiceDtoAdapter } from 'src/app/modules/core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import { PaymentCardReaderDataService } from './paymentCardReader.dataservice';
import { PaymentCardReaderModel } from '../../../api/entity/paymentCardReader.model';
import { PaymentCardReaderConverter } from '../../../api/entity/converter/paymentCardReader.converter';

@Injectable({
    providedIn: 'root'
})
export class PaymentCardReaderDataServiceAdapter extends AbstractDataServiceDtoAdapter<PaymentCardReaderModel, PaymentCardReaderConverter> {
    constructor(dataService: PaymentCardReaderDataService, converter: PaymentCardReaderConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): PaymentCardReaderModel {
        return new PaymentCardReaderModel();
    }
}
